export default (state, action) => {
  return Object.assign({}, state, {
    ...state,
    data: { ...state.data, wishlist: action.wishlist }
  });
};
